import { Badge, Box, Image, Stack, Text, Title } from '@mantine/core'
import { Link } from '@tanstack/react-router'
import type { BoxProps, StackProps } from '@mantine/core'
import type { PickedBlogEntity } from '@/interfaces'
import { convertDate, getFile } from '@/lib/utility'

export const Blogs = ({ blogs, postCardProps, ...props }: { blogs: Array<PickedBlogEntity>; postCardProps?: StackProps } & BoxProps) => {
	return (
		<Box {...props}>
			{blogs.map((blog) => (
				<Stack key={blog._id} gap={'md'} {...postCardProps}>
					<Image src={getFile(blog.image)} alt={blog.title} fit={'cover'} className={'object-cover max-h-56 rounded-lg'} />
					<Stack px={'xs'}>
						<Badge variant={'transparent'}>{convertDate(blog.createdAt)}</Badge>
						<Title className={'text-xl font-bold text-justify'}>{blog.title}</Title>
						<Text className={'text-gray-500'}>{blog.shortDescription}</Text>
						<Link to={`/blog/$url`} params={{ url: blog.url }} className={'text-blue-500 hover:text-blue-600 font-semibold'}>
							Read more
						</Link>
					</Stack>
				</Stack>
			))}
		</Box>
	)
}
